import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import { WEEKDAY_ORDER, DOW } from "../utils/scheduleUtils";
import type { Schedule, DayOfWeek } from "../types";

interface WeekdaysPanelProps {
  schedule: Schedule;
  onToggleDay: (day: DayOfWeek) => void;
}

export const WeekdaysPanel: React.FC<WeekdaysPanelProps> = ({ schedule, onToggleDay }) => (
  <div className={styles.panel_column}>
    <span className={styles.panel_inline_label}>Change on</span>
    <div role="group" aria-label="Days of week" className={styles.weekday_group}>
      {WEEKDAY_ORDER.map((d) => {
        const on = schedule.days.includes(d);
        return (
          <button
            key={d}
            type="button"
            className={`${styles.day_chip} ${on ? styles.day_chip_on : ""}`}
            aria-pressed={on}
            onClick={() => onToggleDay(d)}
          >
            {DOW[d]}
          </button>
        );
      })}
    </div>
  </div>
);
